import { $$ } from 'utils/dom';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { viewport } from '../getViewport';

export const storyImage = () => {
  const images = $$('.story-image');

  if (images.length) {
    images.forEach(image => {
      const items = $$('.story-image__image', image);

      items.forEach(item => {
        gsap.set(item, {
          opacity: viewport.isReduced ? 1 : 0,
          y: 50,
        });
      });

      const timeline = gsap.timeline();

      timeline.to(items, {
        opacity: 1,
        y: 0,
        stagger: {
          from: 'start',
          amount: 0.5,
        },
      });

      ScrollTrigger.create({
        animation: timeline,
        trigger: image,
        start: () => 'top 90%',
        end: () => 'bottom center',
        toggleActions: 'play pause resume reverse',
      });
    });
  }
};
